import { useContext } from "react";
import { ReactReduxContext } from "../components/Context";
import { useReduxContext as useDefaultReduxContext } from "./useReduxContext";
export function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }
  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function() {
    return useContext(context);
  };
  return function useStore2() {
    var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
    return store;
  };
}
export var useStore = /* @__PURE__ */ createStoreHook();
